<style lang="scss" scoped>
@import "$vars";
main {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  >section {
    width: 70%;
    >div {
      width: 100%;
      margin-left: 20px;
      strong {
        color: $color-blue
      }
    }
    figure {
      width: 50px;
    }
  }
}
dt, dd {
  margin: 0
}
dt {
  float: left;
  margin-right: 5px;
}
.submit {
  float: right;
  margin: 20px 0 20px auto;
  padding: 0 80px;
}
</style>

<template>
  <main v-if="loaded">
    <header class="d-flex">
      <p>
        <big><strong>Está tudo certo para você importar seus dados!</strong></big><br /><br />
        Por favor, confirme abaixo todos os dados antes de importar
      </p>
    </header>
    <hr class="col-10" />
    <section class="d-flex">
      <dr-icon fill="blue" name="check"></dr-icon>
      <div>
        <p>
          <big>{{colInfo}}</big>
          <br /><br />
          <strong>Detalhes</strong>
        </p>
        <dl>
          <template v-for="(col, $index) of columns">
            <dt :key="'dt'+$index">{{col[0]}}</dt>
            <dd :key="'dd'+$index">combinado com {{col[1]}}</dd>
          </template>
        </dl>
      </div>
      <button @click="$router.go(-1)" class="btn btn-primary btn-sm">Editar</button>

    </section>
    <hr class="col-12" />
    <dr-submit @click="submit()" class="submit" text="Importar" :sending="sending"></dr-submit>
  </main>
</template>

<script>
import drSubmit from '@/components/form/submit'

export default {
  components: {
    drSubmit
  },
  props: ['selectedOffice', 'fileId'],
  data () {
    return {
      loaded: false,
      sending: false,
      colInfo: null,
      columns: []
    }
  },
  computed: {
    getType () {
      return this.$route.params.type
    }
  },
  mounted () {
    this.fn_SHOW_PROGRESS()
    this.$http.get(`/doctor/doctor_office/${this.selectedOffice.id}/${this.getType}/import/${this.fileId}/action_preview `, this.$store.getters.getAuthHeader).then(
      (res) => {
        this.colInfo = res.data.title
        this.columns = res.data.msg
      }
    ).finally(
      () => {
        this.loaded = true
        this.fn_HIDE_PROGRESS()
      }
    )
  },
  methods: {
    submit () {
      this.sending = true
      this.fn_SHOW_PROGRESS()
      this.$router.replace(`/doctor/patients/import/${this.$route.params.type}/finished`)
    }
  }
}
</script>
